<template>
  <div class="manage-content">
    <div class="location">企业管理中心 / 企业信息</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <info-basic :name="name"
                  :industry="industry"
                  :phone="phone"
                  :address="address"
                  :content="content">
      </info-basic>
    </div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <info-pic :enterprise_logo="enterprise_logo"
                :enterprise_img="enterprise_img"
                :business_license="business_license"
                :other_documents="other_documents">
      </info-pic>
    </div>
  </div>
</template>
<script>
import {epInfo} from '@/config/api.js'
import InfoBasic from './components/InfoBasic'
import InfoPic from './components/InfoPic'
export default {
  name: 'EnterpriseInfo',
  components: {InfoPic, InfoBasic},
  data(){
    return {
      name: '',
      industry: '',
      mobile: '',
      phone: '',
      address: '',
      content:'',
      enterprise_logo: '',
      enterprise_img: [],
      business_license: '',
      other_documents: []
    }
  },
  methods: {
    getInfo(){
      let data = {
        ep_id: this.$store.state.user_id,
        user_type: this.$store.state.user_type,
      };
      this.$post(epInfo, data)
              .then(res => {
                const data = res.data;
                this.name = data.name;
                this.industry = data.industry;
                this.mobile = data.mobile;
                this.phone = data.phone;
                this.address = data.address;
                this.content = data.content;
                this.enterprise_logo = data.enterprise_logo;
                this.enterprise_img = data.enterprise_img;
                this.business_license = data.business_license;
                this.other_documents = data.other_documents;
              })
              .catch(err => {
                window.console.log(err)
              })
    }
  },
  created() {
    this.getInfo()
  }
}
</script>
<style scoped></style>
